
export default function Footer() {
  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          <div>
            <div className="text-2xl font-bold mb-4" style={{ fontFamily: '"Pacifico", serif' }}>
              Strategic
            </div>
            <p className="text-gray-400">
              Data-driven consulting solutions for business growth and transformation.
            </p>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Services</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Business Strategy
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Financial Advisory
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('services')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Change Management
                </button>
              </li>
            </ul>
          </div>
          
          <div>
            <h3 className="font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-2 text-gray-400">
              <li>
                <button 
                  onClick={() => scrollToSection('about')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  About Us
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('team')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Our Team
                </button>
              </li>
              <li>
                <button 
                  onClick={() => scrollToSection('contact')}
                  className="hover:text-white cursor-pointer transition-colors text-left"
                >
                  Contact
                </button>
              </li>
              <li>
                <a 
                  href="https://readdy.ai/?origin=logo" 
                  className="hover:text-white cursor-pointer transition-colors"
                >
                  Made with Readdy
                </a>
              </li>
            </ul>
          </div>
        </div>
        
        <div className="border-t border-gray-800 mt-8 pt-8 text-center text-gray-400">
          <p>&copy; 2024 Strategic Consulting. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
}
